<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Tabs v-model="current" :animated="false" v-if="authRanks.length">
        <TabPane v-for="tab in authRanks" :key="tab.id" :label="tab.name" :name="tab.code">
          <!-- 榜单 -->
          <div class="c-content" v-if="tab.id === 1">
            <div class="c-ranking">
              <!-- filter -->
              <rank-filter @on-change="filterData" />
              <!-- table -->
              <div class="c-ranking-list">
                <top-container
                  :data="quaData"
                  :more="quapage < quaTotalPage"
                  :page-size="pageSize"
                  :loading="qualing"
                  quality
                  @on-more="loadMore('qua')"
                  @on-sort="sortTable('qua', ...arguments)"
                  @on-click="handleShow"
                />
                <top-container
                  :data="potData"
                  :more="potpage < potTotalPage"
                  :page-size="pageSize"
                  :loading="poting"
                  potential
                  @on-more="loadMore('pot')"
                  @on-sort="sortTable('pot', ...arguments)"
                  @on-click="handleShow"
                />
                <top-container
                  :data="danData"
                  :more="danpage < danTotalPage"
                  :page-size="pageSize"
                  :loading="daning"
                  danger
                  @on-more="loadMore('dan')"
                  @on-sort="sortTable('dan', ...arguments)"
                  @on-click="handleShow"
                />
              </div>
            </div>
          </div>
          <!-- 榜单规则 -->
          <div class="c-content" v-else-if="tab.id === 2">
            <set-rules v-if="current === 'M20715'" :games-list="gamesList" :group-list="groupList" />
          </div>
        </TabPane>
      </Tabs>
      <auth-empty v-else />
    </Content>
  </Layout>
</template>
<script>
import { isArray, debounce } from '@/common/js/utils'
import { getPtomGroupGames, getPtomGames, getBillBoard } from '@/api/material.model'

import AuthEmpty from '@/layout/NoAuth.vue'
import RankFilter from './components/rank-filter.vue'
import TopContainer from './components/top-container.vue'
import SetRules from './components/set-rules.vue'
export default {
  name: 'ranking',
  components: { AuthEmpty, RankFilter, TopContainer, SetRules },
  computed: {
    authRanks() {
      const rankAuth = [
        {
          id: 1,
          code: 'M20714',
          name: '素材榜单'
        },
        {
          id: 2,
          code: 'M20715',
          name: '榜单规则'
        }
      ]
      return rankAuth.filter((ret) => this.accessAuth.includes(ret.code))
    }
  },
  data() {
    return {
      accessAuth: this.$store.state.accessAuth,
      current: 'M20714',
      pageSize: 30,
      qualing: null,
      quapage: 1,
      quaTotalPage: 0,
      quasort: '',
      quaorder: '',
      quaData: [],
      obing: null,
      obpage: 1,
      obTotalPage: 0,
      obsort: '',
      oborder: '',
      obData: [],
      poting: null,
      potpage: 1,
      potTotalPage: 0,
      potsort: '',
      potorder: '',
      potData: [],
      daning: null,
      danpage: 1,
      danTotalPage: 0,
      dansort: '',
      danorder: '',
      danData: [],
      params: null,
      gamesList: [],
      groupList: []
    }
  },
  methods: {
    filterData(val) {
      this.params = val
    },
    loadMore(val) {
      const params = Object.assign({}, this.params, { page_size: this.pageSize })
      if (val === 'qua') this.getquaData(params)
      else if (val === 'ob') this.getobData(params)
      else if (val === 'pot') this.getpotData(params)
      else if (val === 'dan') this.getdanData(params)
    },
    sortTable() {
      const type = arguments[0]
      const params = arguments[1]
      const { sort, order } = params
      const param = Object.assign({}, this.params, { page_size: this.pageSize })
      if (type === 'qua') {
        this.quapage = 0
        this.quasort = sort
        this.quaorder = order
        this.quaData = []
        this.getquaData(param)
      } else if (type === 'ob') {
        this.obpage = 0
        this.obsort = sort
        this.oborder = order
        this.obData = []
        this.getobData(param)
      } else if (type === 'pot') {
        this.potpage = 0
        this.potsort = sort
        this.potorder = order
        this.potData = []
        this.getpotData(param)
      } else if (type === 'dan') {
        this.danpage = 0
        this.dansort = sort
        this.danorder = order
        this.danData = []
        this.getdanData(param)
      }
    },
    getquaData(params) {
      this.quapage++
      params = Object.assign({}, params, { page_id: this.quapage, sort: this.quasort, order: this.quaorder, queryType: 1 })
      this.qualing = true
      getBillBoard(params)
        .then((data) => {
          this.qualing = false
          if (data && isArray(data.list)) this.quaData.push(...data.list)
        })
        .catch((err) => {
          this.qualing = false
          this.$Message.error(err)
        })
    },
    getobData(params) {
      this.obpage++
      params = Object.assign({}, params, { page_id: this.obpage, sort: this.obsort, order: this.oborder, queryType: 2 })
      this.obing = true
      getBillBoard(params)
        .then((data) => {
          this.obing = false
          if (data && isArray(data.list)) this.obData.push(...data.list)
        })
        .catch((err) => {
          this.obing = false
          this.$Message.error(err)
        })
    },
    getpotData(params) {
      this.potpage++
      params = Object.assign({}, params, { page_id: this.potpage, sort: this.potsort, order: this.potorder, queryType: 3 })
      this.poting = true
      getBillBoard(params)
        .then((data) => {
          this.poting = false
          if (data && isArray(data.list)) this.potData.push(...data.list)
        })
        .catch((err) => {
          this.poting = false
          this.$Message.error(err)
        })
    },
    getdanData(params) {
      this.danpage++
      params = Object.assign({}, params, { page_id: this.danpage, sort: this.dansort, order: this.danorder, queryType: 4 })
      this.daning = true
      getBillBoard(params)
        .then((data) => {
          this.daning = false
          if (data && isArray(data.list)) this.danData.push(...data.list)
        })
        .catch((err) => {
          this.daning = false
          this.$Message.error(err)
        })
    },
    getData() {
      this.qualing = true
      this.obing = true
      this.poting = true
      this.daning = true
      Promise.all([
        getBillBoard(
          Object.assign({}, this.params, {
            page_id: this.quapage,
            page_size: this.pageSize,
            sort: this.quasort,
            order: this.quaorder,
            queryType: 1
          })
        ),
        getBillBoard(
          Object.assign({}, this.params, {
            page_id: this.obpage,
            page_size: this.pageSize,
            sort: this.obsort,
            order: this.oborder,
            queryType: 2
          })
        ),
        // getBillBoard(
        //   Object.assign({}, this.params, {
        //     page_id: this.potpage,
        //     page_size: this.pageSize,
        //     sort: this.potsort,
        //     order: this.potorder,
        //     queryType: 3
        //   })
        // ),
        getBillBoard(
          Object.assign({}, this.params, {
            page_id: this.danpage,
            page_size: this.pageSize,
            sort: this.dansort,
            order: this.danorder,
            queryType: 4
          })
        )
      ])
        .then((data) => {
          this.qualing = false
          this.obing = false
          this.poting = false
          this.daning = false
          // const [quaData, obData, potData, danData] = data
          const [quaData, potData, danData] = data
          if (isArray(quaData.list) && quaData.page_info) {
            this.quaData = quaData.list
            this.quaTotalPage = quaData.page_info.total_page
          }
          // if (isArray(obData.list) && obData.page_info) {
          //   this.obData = obData.list
          //   this.obTotalPage = obData.page_info.total_page
          // }
          if (isArray(potData.list) && potData.page_info) {
            this.potData = potData.list
            this.potTotalPage = potData.page_info.total_page
          }
          if (isArray(danData.list) && danData.page_info) {
            this.danData = danData.list
            this.danTotalPage = danData.page_info.total_page
          }
        })
        .catch((err) => {
          this.qualing = false
          this.obing = false
          this.poting = false
          this.daning = false
          this.$Message.error(err)
        })
    },
    handleShow(param) {
      const { src, video, row } = param
      const { videoUrl, coverUrl } = row
      const imgs = coverUrl.includes(',') ? coverUrl.split(',') : [coverUrl]
      this.$Gallery.open({ src, video, videoUrl, imgs })
    }
  },
  watch: {
    params: {
      handler() {
        debounce(() => {
          this.quapage = 1
          this.obpage = 1
          this.potpage = 1
          this.danpage = 1
          this.getData()
        }, 600)()
      },
      deep: true
    }
  },
  created() {
    Promise.all([getPtomGames(), getPtomGroupGames()])
      .then((data) => {
        const [game, group] = data
        game && (this.gamesList = game)
        if (isArray(group)) {
          this.groupList = group.map((ret) => {
            return {
              id: ret.groupId,
              name: ret.groupName,
              children: ret.gameIds
            }
          })
        }
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
</script>
<style lang="scss" scoped>
::v-deep .ivu-tabs,
::v-deep .ivu-tabs-content,
::v-deep .ivu-tabs-tabpane {
  height: inherit;
}

.c-content {
  min-width: 1244px;
  height: calc(100% - 40px);
  position: relative;

  .c-ranking {
    height: 100%;
    padding-top: 8px;

    .c-ranking-list {
      height: calc(100% - 48px);
      padding-top: 8px;
      display: flex;
      justify-content: space-between;
      overflow-x: auto;
      padding-bottom: 10px;
    }
  }
}
</style>
